import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Box, Alert } from '@mui/material';
import { CustomButton } from '../../../../components/CustomButton';

export const PromotionActions = ({ 
  onSubmit,
  onCancel,
  loading,
  error,
  isEdit = false
}) => {
  return (
    <Card sx={{ boxShadow: 2 }}>
      <CardContent>
        {error && (
          <Alert variant="filled" severity="error" sx={{ mb: 3, borderRadius: 2 }}>
            {error}
          </Alert>
        )}

        <Box display="flex" justifyContent="flex-end" gap={2} sx={{ pt: 2 }}>
          <CustomButton
            variant="outlined"
            onClick={onCancel}
            disabled={loading}
            sx={{ 
              minWidth: 120,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 500
            }}
          >
            Отменить
          </CustomButton>
          <CustomButton
            type="submit"
            variant="contained"
            loading={loading}
            onClick={onSubmit}
            sx={{ 
              minWidth: 160,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 500
            }}
          >
            {isEdit ? 'Сохранить изменения' : 'Создать акцию'}
          </CustomButton>
        </Box>
      </CardContent>
    </Card>
  );
};

PromotionActions.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
  isEdit: PropTypes.bool
};
